<template>
  <div class="title_tab-container" style="width: 15% !important;">
  <p class="title_tab" >{{$t('tabs.acoplamiento')}} {{ $t('ro_cogeneracion.cogeneracion') }}</p>
  
  

  <hr class="title_tab-divider">
</div>
  <br><div class="contenedor-botones">
   <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
  </div>
  <br>
  <div class="contenedor-tabla">
    <!-- <h3 class="table-header">{{ labels.titulo }}</h3> -->
    <div class="scroll-container">
      <table >
        <thead >
         <!--  <tr>
            <th colspan="10" class="cogeneracion-title">{{ labels.cogeneracion }}</th>
          </tr> -->
          <tr >
            
            <th  rowspan="2" class="encabezado sticky-column">{{$t('acoplamiento_equipos.cogeneracion.acoplado')}}</th> 
          </tr>
          <tr>
            <th style="background-color: #F2F2F2;" ></th>
            <!-- Gris casi blanco F2F2F2
             gris suave e6e6e6
             gris medio CDCDCD
             gris medio+ 686868
             fris fuerte 282828
            
            -->
            <th style="background-color: #F2F2F2;"  v-for="(motor, index) in motoresCogeneracion" :key="'motor-header-' + motor">
              <select
               
                v-model="estadoAcoplamiento[index]" 
                @change="emitirCambioEstado"
                >
                <option value="No">{{$t('acoplamiento_equipos.no')}}</option>
                <option value="Si">{{$t('acoplamiento_equipos.si')}}</option>
              </select>
            </th>
          </tr>
          <tr>
           
            <th class="sticky-column encabezado" style="border-top: 2px solid #D9D9D9;">{{$t('acoplamiento_equipos.cogeneracion.horizonte')}}</th>
            <th  class="sticky-column encabezado">{{$t('acoplamiento_equipos.hora')}}</th>
            <th class="encabezado" v-for="motor in motoresCogeneracion" :key="'motor-name-' + motor">
              {{ motor }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in acoplamientoLocal" :key="index" class="tabla-hover">
            <td class="primera_columna sticky-column">{{ row.horizonte }}</td>
            <td class="sticky-column primera_columna" style="text-align: center !important;">{{ row.hora}}</td>
            <td v-for="motor in motoresCogeneracion" :key="'row-' + motor">
              <div style="display: flex; align-items: center; justify-content: center;">
              <input
              type="number"
              :value="(row.acoplamiento[motor] * 100).toFixed(0)"
              @input="actualizarValor($event.target.value, row, motor)"
              :disabled="opcEjec === 0 || opcEjec === 1"
              min="0"
              max="100"
              step="1"
              style="width: 100px; text-align: center; padding-left: 10% !important;"
            />
            <span style="margin-left: 4px;">%</span>
            </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
//import Papa from "papaparse";
import Swal from 'sweetalert2';

export default {
  props: {
    modelValue: Array,
    estadoAcoplamientoPadre: Array,
    horizonte: Number,
    opcEjec: Number,
    opcEjecTexto: String
  },
  data() {
    return {
      motoresCogeneracion: [...Array(8)].map((_, i) => `Motor cogeneración ${i + 1}`),
      
      labels: {
        titulo: "Acoplamiento",
        horizonte: "Horizonte",
        acoplado: "¿Acoplado?",
        cogeneracion: "Cogeneración"
      }
    };
  },
  computed: {
    acoplamientoLocal: {
      get() {
        return this.modelValue.length ? [...this.modelValue] : [];
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    },
    estadoAcoplamiento: {
      get() {
        return this.estadoAcoplamientoPadre.length ? [...this.estadoAcoplamientoPadre] : [];
      },
      set(value) {
        this.$emit("update:estadoAcoplamiento", value);
      }
    }
  },
 
  methods: {
    /*generarFilasAcoplamiento(horizonte) {
      this.acoplamientoLocal = [];
      const fechaManana = new Date();
      fechaManana.setDate(fechaManana.getDate() + 1);

      const formatoFechaHora = (fecha, hora) => {
        return `${fecha.getDate()}-${fecha.getMonth() + 1}-${fecha.getFullYear()} ${hora}:00`;
      };

      let contadorHoras = 1;

      for (let dia = 0; dia < horizonte; dia++) {
        const fechaActual = new Date(fechaManana);
        fechaActual.setDate(fechaManana.getDate() + dia);

        for (let hora = 0; hora < 24; hora++) {
          this.acoplamientoLocal.push({
            horizonte: formatoFechaHora(fechaActual, hora),
            hora: `H${contadorHoras}`,
            acoplamiento: this.motoresCogeneracion.reduce((acc, motor) => {
              acc[motor] = 1;
              return acc;
            }, {})
          });
          contadorHoras++;
        }
      }
      this.emitChanges();
    },*/
    
    emitirCambioEstado() {
      this.$emit("update:estadoAcoplamiento", [...this.estadoAcoplamiento]);
    },
    actualizarValor(valorInput, fila, motor) {
      const valorNumerico = parseFloat(valorInput);

      if (!isNaN(valorNumerico)) {
        // Guarda en p.u. con 4 decimales
        fila.acoplamiento[motor] = +(valorNumerico / 100).toFixed(4);

        // Dispara la actualización hacia el padre
        this.emitChanges();
      }
    },

    emitChanges() {
      // Reemite el array actualizado al padre
      this.$emit("update:modelValue", [...this.acoplamientoLocal]);
    },


    // Exportar a CSV
    exportToCSV() {
      const headers = ["Horizonte",'Hora' ,...this.motoresCogeneracion].join(";");
      const rows = this.acoplamientoLocal.map((row) =>
        [
          row.horizonte,
          row.hora,
          ...this.motoresCogeneracion.map(motor => 
          Math.round((row.acoplamiento[motor] || 0) * 100)
        )
        ].join(";")
      );

      const csvContent = [headers, ...rows].join("\n");
      const BOM = "\uFEFF";
      const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "acoplamiento_cogeneracion.csv";
      a.click();
      URL.revokeObjectURL(url);
    },

    // Importar desde CSV
    importFromCSV() {
      this.$refs.fileInput.click();
    },

    // Helper: porcentaje 0–100 estricto
parsePorcentajeEstricto(raw) {
  const s = String(raw ?? '').trim();
  if (s === '') return { ok:false, motivo:'vacío' };
  const n = Number(s.replace(',', '.'));
  if (!Number.isFinite(n)) return { ok:false, motivo:'no-numérico' };
  if (n < 0 || n > 100) return { ok:false, motivo:'fuera-rango' };
  return { ok:true, val:n };
},

handleUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({ icon: 'error', title: 'Formato no válido', text: 'Solo se admiten archivos .csv.' });
    event.target.value = '';
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const content = e.target.result;
      const lines = String(content).replace(/\r\n/g, '\n').split('\n').filter(Boolean);
      if (lines.length < 2) throw new Error('El CSV está vacío.');

      // ====== CABECERAS (faltantes/sobran/desordenadas) ======
      const HEADERS_OFICIALES = ['Horizonte', 'Hora', ...this.motoresCogeneracion];

      let headers = lines[0]
        .split(';')
        .map((h, i) => (i === 0 ? String(h).replace(/^\uFEFF/, '') : String(h)).trim());

      const faltantes = HEADERS_OFICIALES.filter(h => !headers.includes(h));
      const extrasRaw = headers.filter(h => !HEADERS_OFICIALES.includes(h));
      const extras = extrasRaw.map(x => String(x).trim()).filter(Boolean);

      let desordenadas = [];
      if (faltantes.length === 0 && extras.length === 0) {
        HEADERS_OFICIALES.forEach((h, i) => {
          if (headers[i] !== h) desordenadas.push(`${h} (posición esperada ${i + 1})`);
        });
      }

      const seccion = (titulo, arr) => {
        const items = (arr || []).map(x => String(x).trim()).filter(Boolean);
        return items.length
          ? `<h4 style="margin:6px 0 2px 0;">${titulo}</h4>
             <ul style="margin:0 0 8px 18px; padding:0;">${items.map(x => `<li>${x}</li>`).join('')}</ul>`
          : '';
      };

      if (faltantes.length || extras.length || desordenadas.length) {
        const html =
          `<div style="text-align:left;">
             <p>El CSV no respeta la <b>plantilla oficial</b> (encabezados y orden).</p>
             ${seccion('❌ Faltan', faltantes)}
             ${seccion('⚠️ Sobran', extras)}
             ${seccion('🔄 Desordenadas', desordenadas)}
             <p style="margin-top:6px;"><small>
               Consejo: exporta la plantilla oficial y copia tus datos respetando los encabezados y su orden.
             </small></p>
           </div>`;
        Swal.fire({ icon: 'error', title: 'Encabezados incorrectos', html, width: 800 });
        event.target.value = '';
        return;
      }
      // ====== FIN CABECERAS ======
      /*// Comprobación filas-horizonte
      //const expectedRows = (Number.isFinite(this.horizonte) && this.horizonte > 0)
       // ? this.horizonte * 24
       // : null;

      // Cuenta SOLO filas de datos (excluye cabecera y ignora líneas totalmente vacías)
      const dataLines = lines
        .slice(1)
        .filter(l => l.split(';').some(c => String(c).trim() !== ''));

      if (expectedRows !== null && dataLines.length !== expectedRows) {
        Swal.fire({
          icon: 'error',
          title: 'Número de filas incorrecto',
          html: `Se esperaban ${expectedRows}</b> filas y se recibieron ${dataLines.length}.`,
          
        });
        event.target.value = '';
        return;
      }*/
      // Índices por posición (exigimos orden)
      const IDX = { horizonte: 0, hora: 1 };

      const celdasVacias = [];
      const erroresPorcentaje = [];
      const nuevos = [];

      const raw = (arr, i) => String(arr[i] ?? '').trim();

      for (let i = 1; i < lines.length; i++) {
        const cols = lines[i].split(';');

        // permitir fila totalmente vacía (p.ej. salto final)
        if (cols.every(c => String(c).trim() === '')) continue;

        if (cols.length !== HEADERS_OFICIALES.length) {
          throw new Error(`Fila ${i + 1}: número de columnas inválido (${cols.length}).`);
        }

        const rowNumber = i + 1;
        const horizonteRaw = raw(cols, IDX.horizonte);
        const horaRaw = raw(cols, IDX.hora);

        if (!horizonteRaw) celdasVacias.push(`L${rowNumber}: Horizonte vacío`);
        if (!horaRaw) celdasVacias.push(`L${rowNumber}: Hora vacía`);

        const acop = {};
        this.motoresCogeneracion.forEach((motor, k) => {
          const idx = 2 + k;
          const valRaw = raw(cols, idx);
          if (valRaw === '') celdasVacias.push(`L${rowNumber}: ${motor} vacío`);

          const parsed = this.parsePorcentajeEstricto(valRaw);
          if (!parsed.ok) {
            erroresPorcentaje.push(
              `L${rowNumber}: ${motor}="${valRaw}"${
                parsed.motivo === 'no-numérico' ? ' (no numérico)' :
                parsed.motivo === 'fuera-rango' ? ' (0 a 100)' : ' (vacío)'
              }`
            );
          } else {
            // guardar en p.u. con 4 decimales
            acop[motor] = +(parsed.val / 100).toFixed(4);
          }
        });

        nuevos.push({
          horizonte: horizonteRaw,
          hora: horaRaw,
          acoplamiento: acop
        });
      }

      if (celdasVacias.length || erroresPorcentaje.length) {
        const bloques = [];
        if (celdasVacias.length) {
          bloques.push(
            `<h4 style="margin:8px 0 4px 0;">Celdas obligatorias vacías</h4>
             <div style="max-height:35vh;overflow:auto;text-align:left">
               ${celdasVacias.slice(0, 400).join('<br>')}${celdasVacias.length > 400 ? '…' : ''}
             </div>`
          );
        }
        if (erroresPorcentaje.length) {
          bloques.push(
            `<h4 style="margin:8px 0 4px 0;">Valores inválidos (deben ser 0–100)</h4>
             <div style="max-height:35vh;overflow:auto;text-align:left">
               ${erroresPorcentaje.slice(0, 400).join('<br>')}${erroresPorcentaje.length > 400 ? '…' : ''}
             </div>`
          );
        }

        Swal.fire({ icon:'error', title:'Errores en datos', html:bloques.join('<br>'), width:900 });
        event.target.value = '';
        return;
      }

      // Todo correcto → importar TODO
      this.acoplamientoLocal = nuevos; // usa el setter del computed
      Swal.fire({ icon:'success', title:'Importación correcta', text:`${nuevos.length} filas importadas.` });
    } catch (err) {
      Swal.fire({ icon:'error', title:'Error al importar', text: err?.message ?? 'Archivo no válido.' });
    } finally {
      event.target.value = ''; // limpia input
    }
  };

  reader.readAsText(file, 'utf-8');
}
  },
  
};
</script>

<style scoped>
/* Contenedor principal */
.contenedor-tabla {
  width: 95%;
  margin: auto;
  overflow: hidden;
}
.contenedor-botones {
  margin-left: 15px; 
}

/* Contenedor con scroll */
.scroll-container {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 200px); 
  overflow-x: auto;
  overflow-y: auto;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

/* Cabecera */
.table-header {
  font-size: 1.5em;
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
  color: white;
  background-color: #686868;
  border-radius: 10px;
  padding: 5px;
}
thead {
    position: sticky;
    font-size:14px;
    top: 0;
    background-color: white;
    z-index: 10;
  }

/* Tabla */
table {
  width: 100%;
  font-size:14px;
  border-collapse: collapse;
  text-align: center;
}

/* Títulos de cogeneración */
.cogeneracion-title {
  background-color: #686868;
  color: white;
  font-weight: bold;
  text-align: center;
}

/* Encabezados */
th {
  /* border: 2px solid #D9D9D9; */
  background-color: white;
  color: #686868;
  padding: 5px;
}

/* Ajustes */
.horizonte, .acoplado {
  background-color: white;
}

/* Celdas */
/* td {
  font-weight: bold;
  color: #686868;
  border: 2px solid #D9D9D9;
  padding: 5px;
  background-color: #F2F2F2;
} */

/* Select */
select {
  width: 100%;
  border-radius: 4px;
  text-align: center;
  color: #686868;
  padding: 5px;
}
input{
  color: #024e74;
}

/* Columnas fijas */
.sticky-column {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 2;
  border-right: 2px solid #D9D9D9;
}

.sticky-column:nth-child(2) {
  left: 80px;
}
</style>
